var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login-body"},[_c('div',{staticClass:"content_box"},[_c('div',{staticClass:"img_box"},[_c('img',{attrs:{"src":require("@/assets/img/login/logo.png"),"alt":""}})]),_c('div',{staticClass:"nc_box"},[_c('div',{attrs:{"id":"nc"}})])])])
}]

export { render, staticRenderFns }